import { sanitizePhoneNumber } from "../../../Utils/onboarding/sanitizePhoneNumber"
import { formatPhoneNumber } from "../../../Utils/phone/formatPhoneNumber"

export const isBackspaceOnFormattingChar = (event) => {
  const input = event.currentTarget
  const cursorPosition = input.selectionStart
  const valueBeforeCursor = input.value.slice(0, cursorPosition)

  return /\D$/.test(valueBeforeCursor)
}

export const getPhoneAfterBackspace = ({ inputValue, maxLength, code, countryCode }) => {
  const rawNumber = sanitizePhoneNumber(inputValue, maxLength)
  const nextRawNumber = rawNumber.slice(0, -1)

  return {
    rawNumber: nextRawNumber,
    number: formatPhoneNumber(code, nextRawNumber, countryCode)
  }
}
